import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function asyncCommandReducer(state = initialState.pendingAsyncCommands, action) {
  switch (action.type) {
    case types.BEGIN_ASYNC_COMMAND:
      return [...state, action.payload];
    case types.SIGNAL_R_EVENT_RECEIVED:
      return state.filter(({ correlationId }) => correlationId !== action.event.correlationId);
    case types.END_ASYNC_COMMAND:
      return state.filter(({ correlationId }) => correlationId !== action.payload.correlationId);
    default:
      return state;
  }
}
